import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef
} from '@angular/core';

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
    standalone: false
})
export class PopoverComponent implements AfterViewInit {

    @Input() content: TemplateRef<any>;

    @Input() popoverText: string;
    @Input() placement: string;
    @Input() popoverType: string;
    @Input() popoverTextParam: string;
    @Output() viewReady = new EventEmitter<void>();

    constructor() {
    }

    ngAfterViewInit() {
        this.viewReady.emit();
    }
}
